import { render } from "./IconsQuestion.vue?vue&type=template&id=1c9fa655&scoped=true"
import script from "./IconsQuestion.vue?vue&type=script&lang=js"
export * from "./IconsQuestion.vue?vue&type=script&lang=js"

import "./IconsQuestion.vue?vue&type=style&index=0&id=1c9fa655&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9fa655"]])

export default __exports__